import { useTheme } from "@emotion/react";
import useStyles from "./styles";
import { DataGrid } from "@mui/x-data-grid";
import { v4 as uuidv4 } from "uuid";

export default function DatagridComponent(params) {
  const {
    rows = [],
    columns = [],
    loading = false,
    setSelectedRow = () => {},
    isPagination = false,
    sxDatagrid = {},
    options = {},
    apiRef,
  } = params;
  const theme = useTheme();
  const styles = useStyles(theme);
  const handleRowClick = (params) => {
    setSelectedRow(params?.row);
  };

  return (
    <DataGrid
      apiRef={apiRef}
      onRowClick={handleRowClick}
      loading={loading}
      columns={columns}
      rows={rows}
      pageSizeOptions={!isPagination ? [100] : [25, 50, 100]}
      hideFooterPagination={!isPagination && rows.length <= 100}
      hideFooter={!isPagination && rows.length <= 100}
      density="compact"
      disableColumnMenu
      disableRowSelectionOnClick
      getRowHeight={() => (isPagination ? 28 : "auto")}
      autoHeight={rows.length <= 4}
      autosizeOptions={{ includeOutliers: true }}
      getRowClassName={(params) =>
        Number(params?.indexRelativeToCurrentPage) % 2 === 1
          ? "linha-impar"
          : "linha-par"
      }
      initialState={{
        pagination: {
          paginationModel: {
            pageSize: !isPagination ? 100 : 25,
          },
        },
        columns: {
          columnVisibilityModel: {
            id: false,
          },
        },
      }}
      sx={{
        ...styles.datagrid,
        ...sxDatagrid,
      }}
      {...options}
    />
  );
}
